import { SidenavMenu } from './sidenav-menu.model';

export const sidenavMenuItems = [ 
    new SidenavMenu (1, 'HOME', '/', null, null, false, 0),
    new SidenavMenu (2, 'ABOUT US', '/', null, null, false, 0),
    new SidenavMenu (3, 'MERCHANTS', '/', null, null, false, 0),
    new SidenavMenu (4, 'BARS', '/', null, null, false, 0),
    new SidenavMenu (5, 'SHOP', '/', null, null, false, 0),

]